import React from 'react';
import {Link} from 'react-router-dom';


const StockCard = ({
                    name, prevClose ,change, 
                    changePercent, exchange, currency, ticker, 
                  }) => {

    // Stock Card UI
    return (
        <>
               <div 
                className='card shadow py-4 px-3 fb-3 flex-fill border-1 border rounded-5 d-flex flex-column justify-content-between'
                style={{width: "30%", height: "11.5rem"}}>
                    <h5>{name}</h5>
                    <p>
                        <small className="d-inline-block me-4">
                               <small> <strong>{prevClose ? prevClose : exchange}</strong></small>
                        </small>
                        {
                            currency ? <small><small><strong>{currency}</strong></small></small>: <></>
                        }
                        <small className="d-inline-block me-4"
                               style={{color: `${change > 0 ? "green" : "red"}`}}>
                                {change}
                        </small>

                        <small className="d-inline-block me-4"
                               style={{color: `${changePercent > 0 ? "green" : "red"}`}}>
                                {changePercent? `${changePercent} %`: ""}
                        </small>
                    </p>
                    <div>
                        <button className="d-inline-block btn btn-primary btn-sm px-3"
                                                    style={{color: "white"}}>
                            <small>
                                <strong>
                                    <Link to={`/stock/details/${ticker}`} style={{color: "white", textDecoration:"none"}}>
                                        Explore
                                    </Link>
                                </strong>
                                </small>
                        </button>
                </div>
            </div>  
        </>
    )
}

export default StockCard
